/** Tabs — Radix-powered, NVL-styled. */
import { forwardRef } from "react";
import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cn } from "../../lib/cn";

export const Tabs = TabsPrimitive.Root;

export const TabsList = forwardRef(function TabsList({ className, ...props }, ref) {
  return (
    <TabsPrimitive.List
      ref={ref}
      className={cn(
        "inline-flex items-center gap-1 p-1 rounded-full bg-surface border border-line-2",
        className
      )}
      {...props}
    />
  );
});

export const TabsTrigger = forwardRef(function TabsTrigger({ className, ...props }, ref) {
  return (
    <TabsPrimitive.Trigger
      ref={ref}
      className={cn(
        "px-4 py-2 text-[13px] font-medium rounded-full text-text-dim hover:text-text transition-colors",
        "data-[state=active]:bg-bg-elev data-[state=active]:text-text data-[state=active]:shadow-card",
        className
      )}
      {...props}
    />
  );
});

export const TabsContent = forwardRef(function TabsContent({ className, ...props }, ref) {
  return (
    <TabsPrimitive.Content
      ref={ref}
      className={cn("mt-6 focus-visible:outline-none animate-fade-in", className)}
      {...props}
    />
  );
});
